import "@nextgisweb/jsrealm/with-chunks!@nextgisweb/jsrealm/plugin/meta"
import entrypoint from "@nextgisweb/jsrealm/entrypoint";
import { registry } from "/opt/ngw/package/nextgisweb/nextgisweb/jsrealm/nodepkg/jsrealm/plugin/meta.ts";
registry.register(
    "pyramid",
    () => entrypoint("@nextgisweb/pyramid/metrics/tab").then(({ registry }) => ({ default: registry })),
    { identity: "@nextgisweb/pyramid/metrics/tab" },
);
registry.register(
    "jsrealm",
    () => entrypoint("@nextgisweb/jsrealm/plugin/testentry/registry").then(({ registry }) => ({ default: registry })),
    { identity: "@nextgisweb/jsrealm/plugin/testentry/registry" },
);
registry.register(
    "jsrealm",
    () => entrypoint("@nextgisweb/jsrealm/testentry/driver").then(({ registry }) => ({ default: registry })),
    { identity: "@nextgisweb/jsrealm/testentry/driver" },
);
registry.register(
    "feature_layer",
    () => entrypoint("@nextgisweb/feature-layer/feature-editor/registry").then(({ registry }) => ({ default: registry })),
    { identity: "@nextgisweb/feature-layer/feature-editor/registry" },
);
registry.register(
    "webmap",
    () => entrypoint("@nextgisweb/webmap/panel/identification/registry").then(({ registry }) => ({ default: registry })),
    { identity: "@nextgisweb/webmap/panel/identification/registry" },
);
export * from "/opt/ngw/package/nextgisweb/nextgisweb/jsrealm/nodepkg/jsrealm/plugin/meta.ts";
if (!registry) throw new Error("Registry '@nextgisweb/jsrealm/plugin/meta' is not defined");
registry.seal();